import React from "react";
import { Link } from "react-router-dom";
import { MonitorPlay, BookOpen, ArrowRight } from "lucide-react";

const CARDS = [
  {
    icon: MonitorPlay,
    image: "/images/edu-video-training.webp",
    alt: "Golden Touch Lash Artistry online video training on a laptop",
    title: "Online Video Training",
    text: "Learn the technique at your own pace with step-by-step professional instruction.",
    cta: "Watch & Learn",
    to: "/shop",
  },
  {
    icon: BookOpen,
    image: "/images/edu-ebooks.webp",
    alt: "The Lash Manual and Lash Mapping Guide e-books by Golden Touch",
    title: "E-Books & Guides",
    text: "Digital guides created to educate, reference and support your artistry.",
    cta: "Shop E-Books",
    to: "/shop?collection=ebooks",
  },
];

export default function OnlineEducation() {
  return (
    <section
      className="bg-onyx pt-14 pb-4 sm:pt-20"
      aria-labelledby="online-education-heading"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-10">
        {/* Header */}
        <div className="reveal text-center">
          <div className="flex items-center justify-center gap-4">
            <span className="h-px w-10 bg-gold/50" />
            <p className="eyebrow">Online Education</p>
            <span className="h-px w-10 bg-gold/50" />
          </div>
          <h2
            id="online-education-heading"
            className="mt-4 font-display text-4xl leading-[1.05] text-ivory sm:text-5xl md:text-6xl"
          >
            Learn at Your Own Pace.
          </h2>
          <p className="font-script -mt-1 text-4xl leading-none text-gold sm:text-5xl md:text-6xl">
            Elevate Your Artistry.
          </p>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-muted-ivory sm:text-base">
            Professional online training and digital resources created for beauty
            artists who are serious about growth, confidence, and mastering their
            craft.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-10 grid grid-cols-2 gap-3 sm:mt-12 sm:gap-6 md:gap-8">
          {CARDS.map(({ icon: Icon, image, alt, title, text, cta, to }) => (
            <div
              key={title}
              className="reveal rounded-2xl border border-gold/40 bg-gradient-to-br from-charcoal to-onyx p-3 sm:p-5"
            >
              <div className="flex h-full flex-col gap-3 sm:gap-4">
                <div className="img-zoom overflow-hidden rounded-xl">
                  <img
                    src={image}
                    alt={alt}
                    loading="lazy"
                    decoding="async"
                    className="aspect-[3/2] w-full object-cover"
                  />
                </div>
                <div className="flex flex-1 flex-col">
                  <Icon
                    className="self-start text-gold"
                    size={30}
                    strokeWidth={1.4}
                    aria-hidden="true"
                  />
                  <h3 className="mt-2 font-display text-lg uppercase leading-[1.1] tracking-wide text-ivory sm:mt-3 sm:text-2xl md:text-3xl">
                    {title}
                  </h3>
                  <span className="mt-2 block h-px w-12 bg-gold/50 sm:mt-3" />
                  <p className="mt-2 text-xs leading-relaxed text-muted-ivory sm:mt-3 sm:text-sm">
                    {text}
                  </p>
                  <div className="mt-4 sm:mt-auto sm:pt-5">
                    <Link
                      to={to}
                      className="btn-gold inline-flex items-center gap-1.5 rounded px-3 py-2.5 text-[0.6rem] uppercase tracking-[0.12em] sm:gap-2 sm:px-6 sm:py-3 sm:text-[0.7rem] sm:tracking-[0.2em]"
                    >
                      {cta}
                      <ArrowRight size={14} className="shrink-0" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
